import { render, staticRenderFns } from "./app-menu.vue?vue&type=template&id=5cc1715f&scoped=true"
import script from "./app-menu.vue?vue&type=script&lang=js"
export * from "./app-menu.vue?vue&type=script&lang=js"
import style0 from "./app-menu.vue?vue&type=style&index=0&id=5cc1715f&prod&lang=scss&scoped=true"
import style1 from "./app-menu.vue?vue&type=style&index=1&id=5cc1715f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cc1715f",
  null
  
)

export default component.exports